import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './style.css';
import { authId } from '../../utils/auth';
import { Heart, Home, LogIn, LogOut, Menu, MessageSquare, PlusSquare, Search, Users, X } from 'react-feather';
import { useAuth } from '../../contexts/auth-context';
import { User } from '../../types';
import { AddAccount } from '../add-account';
import { NavbarThemes } from '../navbar-themes/indext';
import { useTheme } from '../../contexts/theme-context';
import { useTranslation } from "react-i18next";

type Position = 'absolute' | 'relative' | 'fixed' | 'sticky' | 'static';
interface NavbarMobileProps {
    position?: Position
    linkProfile?: string
    children?: React.ReactNode;
    className?: string;
    bottomPadding?: number;
    hideAccount?: boolean;
}

const NavbarMobile: React.FC<NavbarMobileProps> = ({ position, children, className, bottomPadding, linkProfile, hideAccount }) => {
    const { t } = useTranslation();
    const [isDropdownVisible, setDropdownVisible] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const path = location.pathname;
    const { isAuthenticated } = useAuth();
    const { hideMenuMobile, isLiquidGlass } = useTheme();


    useEffect(() => {
        if(!hideMenuMobile) return;
        let lastScrollY = window.scrollY;

        const handleScroll = () => {
            const menu = document.querySelector('.navbar-cel') as HTMLElement;
            const addNewPacoca = document.querySelector('.nav-item-add-new-pacoca') as HTMLElement;
            if (!menu) return;

            if (window.innerWidth <= 850) {
                if (window.scrollY > lastScrollY) {
                    menu.classList.add("hidden-bottom-menu");
                    if(addNewPacoca) addNewPacoca.classList.add("hidden-new-pacoca");
                } else {
                    menu.classList.remove("hidden-bottom-menu");
                    if(addNewPacoca) addNewPacoca.classList.remove("hidden-new-pacoca");
                }
            }
            lastScrollY = window.scrollY;
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [path]);

    // esconde menu - comentarios
    useEffect(() => {
        if(!hideMenuMobile) return;
        const modalBody = document.getElementById("modal-comments-body") as HTMLElement | null;
        const isNavbarStatic = document.getElementById("is-navbar-static") as HTMLElement | null;
        if (modalBody) {
            let lastScrollY = modalBody.scrollTop; // Correção aqui
            const menu = document.querySelector('.navbar-cel') as HTMLElement;
            if (!menu) return;

            if(isNavbarStatic) menu.style.position = "static"

            const handleScroll = () => {

                menu.style.position = "static"

                if (window.innerWidth <= 850) {
                    if (modalBody.scrollTop > lastScrollY) { // Correção aqui
                        menu.classList.add("hidden-bottom-menu-sceen");
                    } else {
                        menu.classList.remove("hidden-bottom-menu-sceen");
                    }
                }
                lastScrollY = modalBody.scrollTop; // Correção aqui
            };

            modalBody.addEventListener('scroll', handleScroll); // Correção aqui

            return () => {
                modalBody.removeEventListener('scroll', handleScroll); // Correção aqui
            };
        }
    }, [path]);

    // esconde menu - chat
    useEffect(() => {
        const modalBody = document.getElementById("row-chat-conteudo") as HTMLElement | null;
        if (modalBody) {
            let lastScrollY = modalBody.scrollTop; // Correção aqui

            const handleScroll = () => {
                const menu = document.querySelector('.navbar-cel') as HTMLElement;
                if (!menu) return;

                menu.style.position = "static"

                if (window.innerWidth <= 850) {
                    if (modalBody.scrollTop > lastScrollY) { // Correção aqui
                        menu.classList.add("hidden-bottom-menu-chat");
                    } else {
                        menu.classList.remove("hidden-bottom-menu-chat");
                    }
                }
                lastScrollY = modalBody.scrollTop; // Correção aqui
            };

            modalBody.addEventListener('scroll', handleScroll); // Correção aqui

            return () => {
                modalBody.removeEventListener('scroll', handleScroll); // Correção aqui
            };
        }
    }, [path]);

    return (
        <div className="user-select-none menu-cel-input">
            {isDropdownVisible && (
                <div className="dropdown-overlay" onClick={() => setDropdownVisible(false)}></div>
            )}
            <nav className={`${className} navbar navbar-cel navbar-dark fixed-bottom nav-mobile`} style={{position: position || "fixed", paddingBottom: isLiquidGlass ? 5 : bottomPadding, bottom: isLiquidGlass ? (Number(bottomPadding) + 10) : 0 }}>
                <div className="container-fluid">
                    <NavbarThemes/>

                    <div className="row">
                        <div className="col">
                            <span className="navbar-nav me-auto mb-lg-0">
                                {children}

                                {isAuthenticated ? (
                                    <>
                                        {!hideAccount ? (
                                            <AddAccount isDropdownVisible={isDropdownVisible} setDropdownVisible={setDropdownVisible} bottomPadding={bottomPadding} linkProfile={linkProfile} isMobile={true}/>
                                        ) : null}
                                    </>
                                ) : (
                                    <>
                                        <span className="nav-item">
                                                <Link aria-label="Ir para tela de login" className="nav-link btn-login-menu position-relative" to="/login">
                                                    <span className="menu-loggout">{t("login.title")}</span>
                                                </Link>
                                            </span>
                                            <span className="nav-item">
                                                <Link aria-label="Ir para tela de login" className="nav-link btn-login-menu position-relative" to="/cadastro">
                                                    <span className="menu-loggout">{t("login.register")}</span>
                                                </Link>
                                        </span>
                                    </>
                                )}
                            </span>
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default NavbarMobile;
